import $ from '../$';
import merge from '../functions/merge';
import unique from '../functions/unique';
import { JQ } from '../JQ';
import './get';
$.fn.add = function (selector) {
    return new JQ(unique(merge(this.get(), $(selector).get())));
};
